var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('AnpassbareSeite',{attrs:{"excelData":_vm.excelData}}),_c('v-container',[_c('h3',{attrs:{"align":"center"}},[_vm._v("Anfragen zum Leasing")]),_c('Anfragen',{attrs:{"anfrageArt":'zum Leasing'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }